export default "__VITE_ASSET__ec5b0c5c__"